import { CSSProperties, defineComponent, PropType } from 'vue'
import * as assets from './assets'

export const svgIconNames = ['down-indicator', 'check'] as const

export type IconNameType = typeof svgIconNames[number]

export const SvgIcon = defineComponent({
  props: {
    name: { type: String as PropType<IconNameType>, required: true },
    size: {
      type: String as PropType<Required<CSSProperties['height']>>,
      default: '1rem',
    },
  },
  setup (props) {
    const camelize = (s: string) => s.replace(/-./g, x => x[1].toUpperCase())

    return () => {
      const { name, size } = props
      return (
        <div
          class="flex justify-center items-center"
          style={{ width: size, height: size }}
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {assets[camelize(name) as unknown as keyof typeof assets]?.()}
          </svg>
        </div>
      )
    }
  },
})
